import React from 'react'
import { Skeleton } from 'antd'
import { useTranslation } from 'lib/i18n'

import Heading from 'components/Heading/Heading'
import MarkdownContent from 'components/MarkdownContent/MarkdownContent'

import { ProfileAndClassNameProps } from '../type'

import styles from './Description.module.css'

const Description: React.FC<ProfileAndClassNameProps> = ({
  profile,
  showDescription,
}) => {
  const { t } = useTranslation()

  if (!profile || !profile?.description) return null
  const { name, description } = profile

  return (
    <section data-cy="profilePageDescription">
      <Heading>
        <h3 className={styles.title}>
          {t('ProfilePage.Description.title', 'About {{name}}', { name })}
        </h3>
      </Heading>
      <Skeleton active loading={!showDescription} paragraph={{ rows: 0 }} />
      {showDescription && (
        <section data-cy="profilePageDescriptionText">
          <MarkdownContent source={description} />
        </section>
      )}
    </section>
  )
}

export default Description
